<template>
  <wrapper-edit
    wrapper-width="100%"
    @back="paasPageBack"
    offsetHeight=70 class="category-edit-wrap">
    <Form ref="paasForm" slot="form"
          :model="paasFormData"
          :rules="paasFormRules"
          :label-width="defaultLabelWidth">
      <Row>
        <FormItem label="分类名称:" prop="title" class="ivu-col-span-12">
          <Input v-model="paasFormData.title" placeholder="分类名称"></Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="商品销售属性:" prop="saleAttr" class="ivu-col-span-12">
          <Enum :enumJsonKey="'crmdict-saleAttr'"  v-model="paasFormData.saleAttr" type="checkbox">
          </Enum>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="排序:" prop="displayOrder" class="ivu-col-span-12">
          <Input v-model="paasFormData.displayOrder" placeholder="排序"></Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="是否显示:" prop="isShow" class="ivu-col-span-12">
          <Enum :enumJsonKey="'crmdict-isShow'"  v-model="paasFormData.isShow" type="radio">
          </Enum>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="分类图标(180*180):"  class="ivu-col-span-12">
          <div class="file-upload-list" v-if="paasFormData.pic">
            <template>
              <img :src="paasFormData.pic">
              <div class="file-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView()"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(paasFormData.deleteUrl)"></Icon>
              </div>
            </template>
          </div>
          <div class="fc-upload-btn" ref="uploadBtn" @click="openUploadPanel"
               v-if="!paasFormData.pic && paasFormData.pic === ''">
            <Icon type="md-camera" size="20"/>
          </div>
        </FormItem>
      </Row>
      <div class="edit-oper-toolbar">
        <mButton type="blue" @click="paasFormSubmit('paasForm','','submit')">提交</mButton>
        <mButton type="green" @click="paasFormSubmit('paasForm','','add')">继续添加</mButton>
        <mButton @click="paasPageBack">返回</mButton>
      </div>
      <FileModal id="fileModal"
                 @save-file="saveFileData"
                 thumbnailWidth="180"
                 thumbnailHeight="180"
                 :uploadParams="uploadParams"
                 :uploadAction="uploadAction"
                 @on-close="hiddenModal"
                 v-if="uploadModal"
                 class="paas-file-select"></FileModal>
      <Modal title="图片预览" v-model="visible">
        <img :src="paasFormData.pic" v-if="visible" style="width: 100%">
      </Modal>
    </Form>

  </wrapper-edit>
</template>

<script>
  import wrapperEdit from "@/components/paas/wrapper-edit"
  import metaEdit from '@/assets/js/meta-tree-edit.js'
  import mButton from '@/components/button/m-button'
  import IconSelect from '@/components/icon/icon'
  import Enum from '@/components/paas/enum-form' //枚举渲染
  import SelectTree from '@/components/paas/selectTree'
  import FileModal from '../../../sys/image/select'
  export default {
    name: "edit",
    mixins:[metaEdit],
    components:{wrapperEdit,Enum,SelectTree,mButton,IconSelect,FileModal},
    data(){
      return {
        serviceUrl:"/eb/store/category",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        currentNameFiledName: 'title',
        fieldName:'eb_store_category',
        paasFormData:{
          id:'',
          title:'',
          pic:'',
          addTime:'',
          isShow:'',
          nodeCode:'',
          parentId:'',
          parentName:'',
          displayOrder:'',
          isDelete:'',
          saleAttr:'',
          fileData:'',
          width:'180',
          height:'180',
          deleteUrl:'',
          paasRepeatSubmitFlag:'',
        }, //表单数据对象
        fileList:[],
        paasFormRules:{
          title: [
            { required: true, message: '分类名称不能为空', trigger: 'blur' },
          ],

        },//表单验证规则
        redirectName:'storeCategoryList',
        nextAddName: 'storeCategoryEdit', //保存并添加跳转页面
        uploadModal:false,
        uploadList:[],
        visible:false,
        uploadParams: {
          fileBusinessType: 'storeCategory',
          fileBusinessProp: 'photo',
          fileBusinessId: '',
        },
      }
    },
    computed:{
      uploadAction(){
        return this.$store.state.sysApi+'/sys/file/uploadAttacheSlice';
      }
    },
    methods:{
      /**
       * 进入edit后的逻辑
       * */
      createdCallback(data) {
        this.paasFormData.pic = data.entity.picFile.showUrl;
        this.paasFormData.deleteUrl = data.entity.picFile.deleteUrl;
        this.uploadParams.fileBusinessId = data.paasRepeatSubmitFlag;
      },
      /**
       * 保存前逻辑
       */
      paasFormSubmitBefore(){
        this.paasFormData.fileData = JSON.stringify(this.fileList);
      },
      /**
       * 隐藏附件弹出框
       */
      hiddenModal(){
        this.uploadModal = false;
      },
      /**
       * 打开附件弹出框
       */
      openUploadPanel(){
        this.uploadModal = true;
        //计算当前位置的top以及left
        let top = this.$refs.uploadBtn.getBoundingClientRect().top;
        this.$nextTick(()=>{
          document.getElementById("fileModal").style.top = top+"px";
          document.getElementById("fileModal").style.left = 0;
        });
      },
      /**
       * 选中附件后的操作
       * @param files
       */
      saveFileData(files){
        this.paasFormData.pic = files[0].thumbnailUrl;
        this.paasFormData.deleteUrl = "";
        this.fileList = files;
      },
      handleView () {
        this.visible = true;
      },
      handleRemove (deleteUrl) {
        if(deleteUrl && typeof(deleteUrl) !=="undefined"){
          this.axios.post(deleteUrl).then(res => {
            if(res.code === 200){
              this.paasFormData.pic = "";
              this.$Message.success("附件删除成功");
            }
          }).catch(err =>{
            this.$Message.error('附件删除失败，请重试！');
          });
        }else{
          this.paasFormData.pic = "";
        }
      },
    },
    created(){

    }
  }
</script>

<style scoped>
  .whead {
    height: 38px;
    color: #636363;
    background: #f8f8f8;
    background: -webkit-gradient(linear, left top, left bottom, from(#f8f8f8),to(#e8e8e8));
    background: linear-gradient(to bottom, #f8f8f8 0%,#e8e8e8 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8f8f8', endColorstr='#e8e8e8',GradientType=0 );
  }
  .wrapper{
    margin:0px;
  }
  .ivu-form{
    width:80%;
    margin:0px auto;
  }
  .fc-upload-btn{
    display: inline-block;
    width: 58px;
    height: 58px;
    text-align: center;
    line-height: 58px;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .1);
    margin-right: 4px;
    box-sizing: border-box;
    border: 1px dashed #c0ccda;
    cursor: pointer;
  }
  .upload-modal >>> .ivu-modal-body{
    padding:5px 16px;
  }
  .file-upload-list{
    display: inline-block;
    width: 180px;
    height: 180px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .file-upload-list img{
    width: 100%;
    height: 100%;
  }
  .file-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .file-upload-list:hover .file-upload-list-cover{
    display: block;
  }
  .file-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .category-edit-wrap{
    position:relative;
  }
  .paas-file-select{
    position:absolute;
  }
</style>
